export default __webpack_public_path__ + "static/media/videocam_off_white_48dp.8ed42b93.svg";